import React from 'react'

import { Header } from 'govwell-ui'

import { ColorToken } from 'src/constants/theme/types'

type Props = {
  actions?: React.ReactNode
  city: string
  colorToken?: ColorToken
}
const AIChatTitle = ({ actions, city, colorToken }: Props) => {
  return (
    <Header
      actions={actions}
      colorToken={colorToken}
      title={`Get Instant Answers with${city ? ` ${city}` : ''} AI`}
      subtitle="AI can make mistakes. Double-check important details."
      wrap="nowrap"
    />
  )
}

export default React.memo(AIChatTitle)
